import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const KeyboardShortcutsPanel = () => {
  const navigate = useNavigate();
  const [showPanel, setShowPanel] = useState(false);

  const shortcuts = [
    { key: 'Alt + 1', action: 'Properties', route: '/properties-management-screen', icon: 'Building2' },
    { key: 'Alt + 2', action: 'Certificates', route: '/smart-certificate-expiry-management', icon: 'ShieldCheck' },
    { key: 'Alt + 3', action: 'Maintenance', route: '/maintenance-kanban-workflow-board', icon: 'Wrench' },
    { key: 'Alt + 4', action: 'Reports', route: '/comprehensive-reports-analytics-dashboard', icon: 'BarChart3' },
    { key: 'Alt + Q', action: 'Quick Add', route: null, icon: 'Plus' },
    { key: 'Alt + S', action: 'Search', route: null, icon: 'Search' },
  ];

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e?.altKey) {
        switch(e?.key) {
          case '1':
            e?.preventDefault();
            navigate('/properties-management-screen');
            break;
          case '2':
            e?.preventDefault();
            navigate('/smart-certificate-expiry-management');
            break;
          case '3':
            e?.preventDefault();
            navigate('/maintenance-kanban-workflow-board');
            break;
          case '4':
            e?.preventDefault();
            navigate('/comprehensive-reports-analytics-dashboard');
            break;
          case '?':
            e?.preventDefault();
            setShowPanel(!showPanel);
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [navigate, showPanel]);

  return (
    <>
      <button
        onClick={() => setShowPanel(!showPanel)}
        className="fixed bottom-6 right-6 h-12 w-12 rounded-full bg-accent shadow-warm-xl flex items-center justify-center transition-smooth hover:scale-110 z-50"
        aria-label="Keyboard shortcuts"
      >
        <Icon name="Keyboard" size={20} color="white" />
      </button>
      {showPanel && (
        <div className="fixed inset-0 z-[200] bg-background/80 flex items-center justify-center" onClick={() => setShowPanel(false)}>
          <div className="bg-surface rounded-[14px] p-8 max-w-md w-full mx-4 shadow-warm-2xl" onClick={(e) => e?.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold text-foreground font-heading">Keyboard Shortcuts</h3>
              <button
                onClick={() => setShowPanel(false)}
                className="h-8 w-8 rounded-lg bg-input border border-border flex items-center justify-center transition-smooth hover:bg-muted"
              >
                <Icon name="X" size={16} color="var(--color-muted-foreground)" />
              </button>
            </div>

            <div className="space-y-3">
              {shortcuts?.map((shortcut, index) => (
                <div key={index} className="flex items-center justify-between p-3 rounded-lg bg-input border border-border">
                  <div className="flex items-center gap-3">
                    <Icon name={shortcut?.icon} size={18} color="var(--color-accent)" />
                    <span className="text-sm text-foreground font-caption">{shortcut?.action}</span>
                  </div>
                  <kbd className="px-3 py-1 rounded bg-muted text-xs font-medium text-foreground font-data border border-border">
                    {shortcut?.key}
                  </kbd>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t border-border">
              <p className="text-xs text-muted-foreground text-center font-caption">
                Press <kbd className="px-2 py-0.5 rounded bg-muted text-xs font-medium font-data">Alt + ?</kbd> to toggle this panel
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KeyboardShortcutsPanel;